module.exports = __webpack_public_path__ + "static/media/third-screen.b8ff7422.svg";